import type React from 'react'

const FileIconExcel: React.FC = () => {
  return (
    <svg
      width="14"
      height="18"
      viewBox="0 0 14 18"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M8.0625 4.875V0.625H2.21875C1.32227 0.625 0.625 1.35547 0.625 2.21875V16.0312C0.625 16.9277 1.32227 17.625 2.21875 17.625H11.7812C12.6445 17.625 13.375 16.9277 13.375 16.0312V5.9375H9.125C8.52734 5.9375 8.0625 5.47266 8.0625 4.875ZM9.65625 9.42383L8.0625 12.0469L9.65625 14.7031C9.88867 15.0684 9.62305 15.5 9.22461 15.5H8.32812C8.16211 15.5 7.99609 15.4336 7.89648 15.2676L7 13.7734L6.07031 15.2676C5.9707 15.4336 5.80469 15.5 5.63867 15.5H4.74219C4.34375 15.5 4.07812 15.0684 4.27734 14.7031L5.9375 12.0469L4.31055 9.42383C4.07812 9.05859 4.34375 8.59375 4.74219 8.59375H5.63867C5.80469 8.59375 5.9707 8.69336 6.07031 8.85938L7 10.3203L7.89648 8.85938C7.99609 8.69336 8.16211 8.59375 8.32812 8.59375H9.22461C9.62305 8.59375 9.88867 9.05859 9.65625 9.42383ZM9.125 0.625V4.875H13.375L9.125 0.625Z"
        fill="currentColor"
      />
    </svg>
  )
}

export default FileIconExcel
